export default __webpack_public_path__ + "static/media/camera-icon.3a58d286.svg";